import { FileStateType } from '@/common/types/Files.type';
import { FILES_LIST_BASE_PATH } from '@/config/baseModulesLink.tsx';
import { MyFilesListParamsType } from '@/modules/FileList/queries/myFilesList/myFilesListQuery.type';

export const FILE_LIST_LINKS = {
  newFiles: `/${FILES_LIST_BASE_PATH}/new-files`,
  myFiles: `/${FILES_LIST_BASE_PATH}/list/?fileListParams={}`,
  inProgress: `/${FILES_LIST_BASE_PATH}/in-progress/?fileListParams=${JSON.stringify({ state: { label: 'در حال اجرا', value: FileStateType.IN_PROGRESS } })}`,
  myFilesWithParams: (params: Partial<MyFilesListParamsType>) => {
    for (const key in params) {
      if (!params[key as keyof MyFilesListParamsType]) {
        delete params[key as keyof MyFilesListParamsType];
      }
    }
    const convertedParams = JSON.stringify(params);
    return `/${FILES_LIST_BASE_PATH}/list/?fileListParams=${convertedParams}`;
  },
  myNewFilesWithParams: (params: Partial<MyFilesListParamsType>) => {
    for (const key in params) {
      if (!params[key as keyof MyFilesListParamsType]) {
        delete params[key as keyof MyFilesListParamsType];
      }
    }
    const convertedParams = JSON.stringify(params);
    return `/${FILES_LIST_BASE_PATH}/new-files/?fileListParams=${convertedParams}`;
  },
  addFilterParams: ({
    location,
    params,
  }: {
    location: string;
    params: MyFilesListParamsType;
  }) => {
    const convertedParams = JSON.stringify(params);
    return `${location}?fileListParams=${convertedParams}`;
  },
  resetFileListParams: ({
    location,
    state,
  }: {
    location: string;
    state: MyFilesListParamsType['state'];
  }) => {
    const params = JSON.stringify({ state });
    return state ? `${location}?fileListParams=${params}` : location;
  },
};
